import request from '@/utils/request'

export function verifyContract (params) {
  return request({
    url: '/v2/sec/verifyContract/verifyContract',
    method: 'post',
    data: params
  })
}
export function verifyContractor (params) {
  return request({
    url: '/v2/sec/verifyContract/verifyContractor',
    method: 'post',
    data: params
  })
}
export function verifyEncryptContract (params) {
  return request({
    url: '/v2/sec/verifyContract/verifyEncryptContract',
    method: 'post',
    data: params
  })
}
export function scanContract (ctrno) {
  return request({
    url: '/v2/res/verifyContract/QrCodeScanContract/' + ctrno,
    method: 'get'
  })
}
